
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import React from 'react';
import { GetStaticPaths, GetStaticProps } from 'next/types';
import PostPage from '@/components/PageComponents/PostPage';
import { handleError } from '@/helpers/handleError';
import { GET_POST, GET_LATEST_CATEGORY_POSTS, GET_POST_BY_ID, GET_TOPICS_DATA, GET_FOOTER_DATA, GET_HEADER_DATA, GET_AUTHOR_ARTICLES_TOTAL, GET_COOKIES, } from '@/graphql/queries';
import { addApolloState, initializeApollo } from '@/lib/apolloClient';
export default function Slug(props: any) {
    return <PostPage {...props}/>;
}
const getStaticProps: GetStaticProps = async (context) => {
    try {
        const client = initializeApollo();
        const { data: postData } = await client.query({
            query: GET_POST,
            variables: { slugUrl: context.params?.slug }
        });
        if (!postData.post.data.length) {
            return {
                notFound: true
            };
        }
        const { data: categoryPosts } = await client.query({
            query: GET_LATEST_CATEGORY_POSTS,
            variables: {
                category: postData.post.data[0].attributes.category.data[0].attributes.title,
                id: postData.post.data[0].id
            }
        });
        const postId = postData.post.data[0].id;
        const prevId = +postId === 1 ? +postId + 2 : +postId - 1;
        const { data: { articles: prevArticle }, } = await client.query({
            query: GET_POST_BY_ID,
            variables: { id: prevId }
        });
        const { data: { articles: nextArticle }, } = await client.query({
            query: GET_POST_BY_ID,
            variables: { id: +postData.post.data[0].id + 1 }
        });
        const { data: topicsData } = await client.query({
            query: GET_TOPICS_DATA
        });
        const { data: cookiesData } = await client.query({
            query: GET_COOKIES
        });
        const { data: headerData } = await client.query({
            query: GET_HEADER_DATA
        });
        const { data: footerData } = await client.query({
            query: GET_FOOTER_DATA
        });
        const { data: { articles: { meta: { pagination: { total: authorArticlesTotal }, }, }, }, } = await client.query({
            query: GET_AUTHOR_ARTICLES_TOTAL,
            variables: { authorId: postData.post.data[0].attributes.author.data.id }
        });
        return addApolloState(client, {
            props: {
                ...postData,
                ...topicsData,
                ...categoryPosts,
                ...footerData,
                ...headerData,
                ...cookiesData,
                authorArticlesTotal,
                prevArticle,
                nextArticle
            },
            revalidate: 3600
        });
    }
    catch (error) {
        handleError(error, 'Slug getServerSideProps');
        return {
            notFound: true
        };
    }
};
export const getStaticPaths: GetStaticPaths = async () => {
    const res = await fetch(`${process.env.NEXT_PUBLIC_API_URL}/api/articles?fields[0]=url`);
    const { data: posts } = await res.json();
    const paths = posts.map((post: any) => ({
        params: { slug: post.attributes.url }
    }));
    return { paths, fallback: 'blocking' };
};

    async function __Next_Translate__getStaticProps__1977fa9fda5__(ctx) {
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/blog/[slug]',
            loaderName: 'getStaticProps',
            loadLocaleFrom: typeof __i18nConfig.loadLocaleFrom === 'function' ? __i18nConfig.loadLocaleFrom : (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1977fa9fda5__ as getStaticProps }
  